import type { documents as en } from '@/i18n/locales/en/documents';
import type { Translation } from '@/i18n/types';

export const documents: Translation<typeof en> = {
  page: {
    title: 'Documentos',
    lead: 'Suba y gestione documentos para {{company}}.',
    noScope: 'Seleccione una empresa para ver sus documentos.',
    forbidden: 'No tiene permiso para ver los documentos de esta empresa.',
  },
  upload: {
    title: 'Subir documento',
    titleField: 'Título',
    category: 'Categoría',
    audience: 'Público objetivo',
    fileUrl: 'URL del archivo',
    file: 'Archivo',
    upload_status: {
      uploading: 'Subiendo…',
      tooLarge: 'El archivo es demasiado grande (máx. 10MB).',
      invalidType: 'Tipo de archivo no permitido.',
    },
    fileUrlHint: 'Se sube de inmediato; o introduce una URL existente debajo.',
    requiresReadConfirmation: 'Requiere confirmación de lectura',
    requiresReadConfirmationHint: 'Los miembros deben confirmar que han leído este documento.',
    submit: 'Subir',
  },
  categories: {
    algemeen: 'General',
    beleid: 'Política',
    veiligheid: 'Seguridad',
    hr: 'RR. HH.',
    vitaliteit: 'Vitalidad',
  },
  audiences: {
    iedereen: 'Todos',
    management: 'Dirección',
    per_afdeling: 'Por departamento',
    per_locatie: 'Por ubicación',
  },
  status: {
    gepubliceerd: 'Publicado',
    archief: 'Archivado',
  },
  library: {
    title: 'Biblioteca de documentos',
    empty: 'Todavía no hay documentos.',
    totalViews: 'Total de visualizaciones: {{count}}',
    columns: {
      title: 'Título',
      category: 'Categoría',
      views: 'Visualizaciones',
      status: 'Estado',
    },
  },
  actions: {
    new: 'Subir documento',
    cancel: 'Cancelar',
    publish: 'Publicar',
    archive: 'Archivar',
  },
};
